<template>
  <div class="d-flex align-items-center justify-content-between mb-4">
    <h1 class="m-0">Dashboard</h1>

    <div>
      <div class="input-group input-group-sm">
        <span class="input-group-text" id="dashboard-von-date">von</span>
        <input type="date" class="form-control" aria-label="von date" aria-describedby="dashboard-von-date" v-model="startDate" />
        <!-- @blur="onVertragsbeginnChange()" -->
        <span class="input-group-text" id="dashboard-bis-date">bis</span>
        <input type="date" class="form-control" aria-label="bis date" aria-describedby="dashboard-bis-date" v-model="endDate" />
        <button class="btn btn-outline-secondary" type="button" id="dashboard-date-selection-button" @click="fetchVertragAnalysen()">
          <font-awesome-icon icon="fa-magnifying-glass" />
        </button>
      </div>
    </div>
  </div>

  <div v-if="!loading && vertraegeAnalysen != null" class="row gx-2 mx-0 mb-2">
    <div class="col-2 ps-0">
      <div class="bg-white rounded shadow h-100 pt-3">
        <NeuNachtragPieChart :neuVertraege="vertraegeAnalysen.neuvertragCount" :nachtraege="vertraegeAnalysen.nachtragCount" />
      </div>
    </div>

    <div class="col pe-0">
      <div class="bg-white rounded shadow h-100">
        <NeuNachtragPartnerBarChart :neuVertraege="vertraegeAnalysen.neuvertraegeByPartner" :nachtraege="vertraegeAnalysen.nachtraegeByPartner" />
      </div>
    </div>
  </div>

  <div v-if="!loading && vertraegeAnalysen != null" class="row mx-0 mb-4">
    <div class="col px-0">
      <div class="bg-white rounded shadow">
        <VorlaufzeitPartnerBarChart :neuVertraege="vertraegeAnalysen.neuvertraegeByPartner" :nachtraege="vertraegeAnalysen.nachtraegeByPartner" />
      </div>
    </div>
  </div>

  <LoadingOverlay v-if="loading" />
</template>

<script lang="ts" setup>
  //#region Imports
  import { computed, onMounted, ref } from 'vue';
  import { useStore } from '@/store';
  import { ActionTypes as VertragActionTypes } from '@/store/modules/Vertraege/actions';

  import { FetchVertragAnalysenRequest } from '@/models/VertragModels';

  import NeuNachtragPieChart from '@/components/Dashboard/NeuNachtragPieChart.vue';
  import NeuNachtragPartnerBarChart from '@/components/Dashboard/NeuNachtragPartnerBarChart.vue';
  import VorlaufzeitPartnerBarChart from '@/components/Dashboard/VorlaufzeitPartnerBarChart.vue';

  import LoadingOverlay from '@/components/LoadingOverlay.vue';
  //#endregion

  const store = useStore();

  const loading = computed(() => store.getters.status.getVertragAnalysenLoading);

  const vertraegeAnalysen = computed(() => store.getters.vertragAnalysen);

  const startDate = ref<string | null>(null);
  const endDate = ref<string | null>(null);

  async function fetchVertragAnalysen() {
    await store.dispatch(VertragActionTypes.GetVertragAnalysen, new FetchVertragAnalysenRequest(startDate.value, endDate.value));
  }

  onMounted(async () => {
    const today = new Date();
    const priorDate = new Date().setDate(today.getDate() - 30);

    startDate.value = new Date(priorDate).toISOString().split('T')[0];
    endDate.value = today.toISOString().split('T')[0];

    await fetchVertragAnalysen();
  });
</script>
